if ( typeof ShippingNotice !== 'function' ) {

  class ShippingNotice extends HTMLElement {

    constructor() {
      super();
      this.#init();
    }

    #init() {

       const freeShippingThreshold = Number(this.getAttribute('data-free-shipping'));
      //const freeShippingThreshold = Number(3000);
      const freeShippingPredictThreshold = Number(6000);
      const cartTotal = Number(this.getAttribute('data-cart-total-amount'));
      const freeShippingRemaining = cartTotal - Math.round(freeShippingThreshold * (Shopify.currency.rate ? Number(Shopify.currency.rate) : 1));
      const freeShippingPredictRemaining = cartTotal - Math.round(freeShippingPredictThreshold * (Shopify.currency.rate ? Number(Shopify.currency.rate) : 1));
      let shippingMessage = '';
      let shippingLogo = '';
      let shippingSecondMessage = '';
      let shippingSuccess = false
      let shippingPredictSuccess = false

      //let shippingPointRelais = `<div style="text-align: center;"><img width="40px" src="https://cdn.shopify.com/s/files/1/0657/8623/files/dpd-pickup-logo.png?v=1753209810"><p>En point relais</p></div>`
      let shippingPointRelais = `<div style="text-align: center;"><img width="40px" src="https://cdn.shopify.com/s/files/1/0657/8623/files/mondial_relay.png?v=1769982313"><p>En point relais</p></div>`
      let shippingPredict = `<div style="text-align: center;"><img width="40px" src="https://cdn.shopify.com/s/files/1/0657/8623/files/62b30a4eb223544c209f5e49.png?v=1753214450"><p>À domicile</p></div>`

      if ( freeShippingRemaining < 0 ) {
        shippingMessage = window.KROWN.settings.locales.shipping_notice_remaining_to_free.replace('{{ remaining_amount }}', this._formatMoney(Math.abs(freeShippingRemaining), KROWN.settings.shop_money_format));
        shippingLogo = `<div style="display: flex; justify-content: center; gap: 40px; margin: 10px 0;">${shippingPointRelais}</div>`
        shippingSecondMessage = `<div><p>Le choix du point relais se fait après le paiement, mais vous pouvez déjà consulter <a href="https://www.dpdgroup.com/fr/mydpd/parcel-shops" target="_blank">les points relais proches de chez vous</a>.</p></div>`
      } else {
        if ( freeShippingPredictRemaining < 0 ) {
          shippingMessage = window.KROWN.settings.locales.shipping_notice_eligible_for_free;
          shippingLogo = `<div style="display: flex; justify-content: center; gap: 40px; margin: 10px 0;">${shippingPointRelais}</div>`
          shippingSecondMessage = `<div><p>Le choix du point relais se fait après le paiement, mais vous pouvez déjà consulter <a href="https://www.dpdgroup.com/fr/mydpd/parcel-shops" target="_blank">les points relais proches de chez vous</a>.</p></div>`
          shippingSuccess = true;
        } else {
          shippingMessage = window.KROWN.settings.locales.shipping_notice_eligible_for_free;
          shippingLogo = `<div style="display: flex; justify-content: center; gap: 40px; margin: 10px 0;">${shippingPointRelais}${shippingPredict}</div>`
          shippingSecondMessage = `<div><p>Le choix du point relais se fait après le paiement, mais vous pouvez déjà consulter <a href="https://www.dpdgroup.com/fr/mydpd/parcel-shops" target="_blank">les points relais proches de chez vous</a>.</p></div>`
          shippingSuccess = true;
          shippingPredictSuccess = true;
        }
      }

      if ( this.hasAttribute('data-show-alert') ) {
        this.innerHTML = `
          <div class="alert alert--wide alert--${shippingSuccess ? 'success' : 'note'}" style="flex-direction: column;">
            <div>${shippingMessage}</div>
            ${shippingLogo}
          </div>
          `;
      } else {
        this.innerHTML = shippingMessage;
      }

    }
    
    #formatMoney(cents, format) {

			if (typeof cents === 'string') {
				cents = cents.replace('.', '');
			}
	
			let value = '';
			const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
			const formatString = format || moneyFormat;
	
			function formatWithDelimiters(number, precision, thousands, decimal) {
				thousands = thousands || ',';
				decimal = decimal || '.';
	
				if (isNaN(number) || number === null) {
					return 0;
				}
	
				number = (number / 100.0).toFixed(precision);
	
				const parts = number.split('.');
				const dollarsAmount = parts[0].replace(
					/(\d)(?=(\d\d\d)+(?!\d))/g,
					'$1' + thousands
				);
				const centsAmount = parts[1] ? decimal + parts[1] : '';
	
				return dollarsAmount + centsAmount;
			}
	
			switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, '.', ',');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
				case 'amount_with_apostrophe_separator':
					value = formatWithDelimiters(cents, 2, "'");
					break;
			}
	
			return formatString.replace(placeholderRegex, value);
	
		}

  }

  if ( typeof customElements.get('shipping-notice') === 'undefined' ) {
    customElements.define('shipping-notice', ShippingNotice);
  }

}